import { useState } from 'react';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import CardAction from '../../../../components/card/CardAction';
import './ArchiveOrUnArchiveLessonAction.scss';
import { useArchiveUnarchiveLesson } from './TeacherCoursesActionHooks';
import ConfirmationDialog from '../../../../components/dialog/ConfirmationDialog';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onArchiveSuccess: () => null,
};

export default function ArchiveOrUnArchiveLessonAction(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const {
    courseAssignmentId,
    student,
    date,
    lesson,
    onArchiveSuccess,
  } = mergedProps;
  const [openDialog, setOpenDialog] = useState();

  const icon = lesson.meta.archived ? <UnarchiveIcon /> : <ArchiveIcon />;
  const {
    updateLesson,
  } = useArchiveUnarchiveLesson({
    courseAssignmentId,
    student,
    date,
    onArchiveSuccess,
  });

  return (
    <>
      <CardAction
        icon={icon}
        actionHandler={() => { setOpenDialog(true); }}
        className={`archive-unarchive-lesson-action ${lesson.meta.archived ? 'archived' : ''}`}
        title='Archive'
        ariaLabel='Archive'
        tabIndex={0}
        aria-hidden='false'
      />
      {openDialog ? (
        <ConfirmationDialog
          open={openDialog}
          title='Archive Lesson'
          contentText={`Are you sure you want to archive and delete this activity on all assigned dates for ${student.userName}?`}
          confirmLabel='Ok'
          cancelLabel='Cancel'
          onConfirm={() => { setOpenDialog(false); updateLesson(lesson); }}
          onCancel={() => { setOpenDialog(false); }}
        />
      ) : null}
    </>
  );
}
